import useProfile from "api/UserResource/useProfile";
import ChangeEmailAddress from "./ChangeEmailAddress";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import AccountLayout from "../AccountLayout";

const Emails = () => {
	const { data: profile, isLoading: isLoadingProfile } = useProfile();

	return (
		<Container>
			<div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
				<div className="pt-6 pb-12">
					<PaddingX>
						<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
							{/* Header Section */}
							<div className="mb-8">
								<h1 className="text-2xl font-semibold ">Email Settings</h1>
								<p className="text-gray-600 leading-relaxed">
									Manage your email address and notification preferences. Your email is used for
									login and important updates.
								</p>
							</div>

							{/* Email Management */}
							<ChangeEmailAddress />
						</AccountLayout>
					</PaddingX>
				</div>
			</div>
		</Container>
	);
};

export default Emails;
